module.exports = __webpack_public_path__ + "img/更多盲盒.13c361f3.png";